<common-empty-input
  [label]="label"
  [labelWidth]="labelWidth"
  [control]="control"
  [required]="required"
>
  <ng-container input>
    <input
      class="{{ inputStyleClass }}"
      type="text"
      [(ngModel)]="formattedValue"
      (input)="onInputChange($event)"
      inputmode="decimal"
      placeholder="$ 0.00"
    />
  </ng-container>
</common-empty-input>
